import React from 'react'
import classnames from 'classnames'
import { formatCurrency } from '../../../utils/utils'
import ChevronUp from '../../../assets/img/chevron_up.png'

const Gutter = props => {
  const { toggleSummaryModal, orderSummary, isLoading } = props

  const grandTotal = (orderSummary && orderSummary.grandTotal) || 0
  return (
    <div className="cookunity__checkout_gutter">
      <div className="layout">
        <div className="total">
          <span>TOTAL</span>
        </div>

        <div
          className={classnames('summary', { loading: isLoading })}
          onClick={toggleSummaryModal}>
          <span className="total_amount">{formatCurrency(grandTotal)}</span>
          <span className="view_details">View Details</span>
        </div>

        <div className="chevron" onClick={toggleSummaryModal}>
          <img src={ChevronUp} alt="chevron" />
        </div>
      </div>
    </div>
  )
}

export default Gutter



// WEBPACK FOOTER //
// ./src/modules/Checkout/Gutter/Gutter.jsx